/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-empty-interface */
import PayMessagePolicy from '@/components/PayMessagePolicy';
import PassengerToPolicy from '@/components/PassengerToPolicy';
import PriceDetails from '@/components/PriceDetails';
import { resetGlobalAll, setOrderId } from '@/slices/global/globalSlice';
import PriceDetailsApi from '@/components/PriceDetailsApi';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { getTotalDiscountAmount } from '@/utils/tripMapping';
import { LoadingButton } from '@mui/lab';
import {
  Box, Stack, Typography,
} from '@mui/material';
import { get, isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

interface TripDetailPriceProps {
  onBtnClick?: () => void;
  isDisabled?: boolean;
  isPayment?: boolean;
  isLoadDataFromApi?: boolean;
}

export const TripDetailPriceComponent = ({
  isPayment, priceDetailsObj, handleNextPage, isLoading, isLoadDataFromApi,
}: any) => {
  const { query, push, asPath } = useRouter();
  const PriceDetailsComponent = isLoadDataFromApi ? PriceDetailsApi : PriceDetails;

  return (
    <Stack spacing={isPayment ? pr`16px` : pr`24px`}>
      <Box
        sx={{
          background: 'white',
          borderRadius: '3px',
        }}
      >
        <PriceDetailsComponent
          isDesktop
          isPayment={isPayment}
          priceDetailsObj={priceDetailsObj}
          flightPriceDiff={priceDetailsObj.flightPriceDiff}
          flightArr={priceDetailsObj.flightArr}
          passenger={priceDetailsObj.passenger}
          baggagePrice={priceDetailsObj.totalBaggagePrice}
          baggagePriceDepart={priceDetailsObj.departBaggagePrice}
          baggagePriceReturn={priceDetailsObj.returnBaggagePrice}
          discountAmount={priceDetailsObj.totalDiscountAmount}
          onCloseButton={() => {}}
          onNextButton={handleNextPage}
        />
      </Box>
      {asPath === '/passenger' && <PassengerToPolicy />}
      {isPayment && (
      <PayMessagePolicy
        sx={{ p: 0 }}
        onToPolicyPage={() => push('/pay/privacy-policy')}
      />
      )}
      <LoadingButton
        color="primary"
        loading={isLoading}
        disabled={isLoading}
        onClick={handleNextPage}
        variant="contained"
        sx={{ p: ` ${pr`12px`} 0` }}
      >
        <Typography
          color={style.color.white4}
          variant="contentBold"
        >
          {query?.type === 'depart' ? 'Chọn vé chiều về' : isPayment ? 'Thanh toán' : 'Tiếp tục'}
        </Typography>
      </LoadingButton>
    </Stack>

  );
};

const TripDetailPrice: React.FC<TripDetailPriceProps> = ({
  onBtnClick,
  isPayment,
  isLoadDataFromApi,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const query = isEmpty(router.query)
    ? qs.parse(router.asPath.split('?')[1]) || {}
    : router.query;
  const [isLoading, setLoading] = useState(!!isPayment);

  const passenger = useAppSelector((state) => state.searchFlightForm.passenger);

  const myBookingFlight = useAppSelector((state) => state.myBooking.flights);

  const selectedFlightCache = useMemo(
    () => myBookingFlight.find(
      (flight) => (flight.bookingCode === query?.code) || (flight.id === Number(query?.id || 0)),
    ),
    [myBookingFlight],
  );

  // const reserveOrderError = useAppSelector((state) => state.global.reserveOrderError);
  const reserveResponse = useAppSelector(
    (state) => state.global.reserveResponse,
  );
  let orderId = useAppSelector((state) => state.global.orderId);
  if (reserveResponse && isLoading) {
    const order = get(reserveResponse, 'orders[0]');
    if (order && order.id) {
      orderId = order.id;
      dispatch(setOrderId({ orderId }));
      // router.push(
      //   {
      //     pathname: '/pay',
      //     query: {
      //       phone: order.contactPhone,
      //       email: order.contactEmail,
      //       value: order.amount,
      //       code: order.code,
      //       id: orderId,
      //     },
      //   },
      //   undefined,
      //   { shallow: true },
      // );
    }
    setLoading(false);
  }

  if (isPayment && !isPayment) {
    setTimeout(
      () => router.push('/route-flight', {}, { shallow: true }),
      60 * 1000,
    );
  }

  useEffect(() => {
    if (selectedFlightCache) {
      setLoading(false);
    }
  }, []);

  const selectedFlight = useAppSelector((state) => state.selectedFlight.flight);
  const selectedReturnFlight = useAppSelector(
    (state) => state.selectedFlight.returnFlight,
  );
  const {
    flightPriceDiff,
    returnFlightPriceDiff,
    discountAmount,
    returnDiscountAmount,
  } = useAppSelector((state) => state.selectedFlight);
  const selectedBaggages = useAppSelector(
    (state) => state.baggage.selectedBaggages,
  );

  if (typeof window !== 'undefined' && !selectedFlight) {
    // router.push('/');
  }

  if (!selectedFlight) {
    return <></>;
  }

  let departBaggagePrice = 0;
  let returnBaggagePrice = 0;
  departBaggagePrice = (selectedBaggages.depart || []).reduce(
    (total, baggageData) => total + baggageData.baggage.price,
    0,
  );
  returnBaggagePrice = (selectedBaggages.return || []).reduce(
    (total, baggageData) => total + baggageData.baggage.price,
    0,
  );

  const totalBaggagePrice = departBaggagePrice + returnBaggagePrice;

  const totalDiscountAmount = getTotalDiscountAmount(
    discountAmount + returnDiscountAmount,
    passenger,
  );
  const handleNextPage = () => {
    if (!router.asPath.includes('add-baggage')) {
      dispatch(resetGlobalAll());
    }
    dispatch(setOrderId({ orderId: '' }));
    onBtnClick?.();
  };
  const priceDetailsObj = {
    flightPriceDiff: flightPriceDiff + returnFlightPriceDiff,
    flightArr: [selectedFlight].concat(
      selectedReturnFlight ? [selectedReturnFlight] : [],
    ),
    passenger,
    totalBaggagePrice,
    departBaggagePrice,
    returnBaggagePrice,
    totalDiscountAmount,
  };
  return (
    <TripDetailPriceComponent
      isLoadDataFromApi={isLoadDataFromApi}
      isPayment={isPayment}
      priceDetailsObj={priceDetailsObj}
      handleNextPage={handleNextPage}
      isLoading={isLoading}
    />
  );
};

export default TripDetailPrice;
